import { render } from "./PaymentReceiptCreateConfirmSubmitModal.vue?vue&type=template&id=399e54b8&scoped=true"
import script from "./PaymentReceiptCreateConfirmSubmitModal.vue?vue&type=script&lang=js"
export * from "./PaymentReceiptCreateConfirmSubmitModal.vue?vue&type=script&lang=js"

import "./PaymentReceiptCreateConfirmSubmitModal.vue?vue&type=style&index=0&id=399e54b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-399e54b8"]])

export default __exports__